import { ACTIVATE_PROCESS_INIT, ACTIVATE_PROCESS_NOT_PROCESSING } from "../action-types/activateProjectProcess"

export const resetActivateProcess = (dispatch) => dispatch({ type: ACTIVATE_PROCESS_NOT_PROCESSING })
export const initActivateProcess = (dispatch) => dispatch({ type: ACTIVATE_PROCESS_INIT })
